module.exports = __webpack_public_path__ + "static/media/customer-logins.3e6c9bda.svg";